define('models/shared/image/image_collection',["backbone"
], function (Backbone) {

    var Image = Backbone.Model.extend({
        parse: function (data) {
            var response = {};
            response.ImageID = data.UIID;
            response.ID = data.UID;
            response.ImageTypeID = data.ITD;
            response.EntityGUID = data.EGID;
            response.ImageName = data.IU;
            response.ImageURL = buildImageURL(pf.enums.entityTypeCodeEnum.Post, data.EGID, pf.enums.imageTypeGUIDEnum.Profile, data.IU);
            //response.redirectImageURL = getImageRedirectURL(response.ImageURL);
            response.redirectImageURL = buildImageURL(pf.enums.entityTypeCodeEnum.Post, data.EGID, pf.enums.imageTypeGUIDEnum.Actual, data.IU,false);
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};
            data.UIID = this.attributes.ImageID;
            data.UID = this.attributes.ID;
            data.ITD = this.attributes.ImageTypeID;
            data.EGID = this.attributes.EntityGUID;
            data.IU = getImageFileName(this.attributes.ImageURL);

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    var ImageList = Backbone.Collection.extend({

        model: Image,
        initialize: function (attributes, options) {
            options || (options = {});
        }
    });
    return ImageList;
});
